export function canView(item) {
  return (item.permissions.view);
}

export function canViewContacts(item) {
  return (item.permissions.contacts);
}

export function canUpdate(item) {
  return (item.permissions.update);
}

export function canDelete(item) {
  return (item.permissions.delete);
}

export const canCreateSub = type => item => item.permissions['create_'+type];



// WEBPACK FOOTER //
// ./src/components/Boilerplate/permissions.js